import type { SelectOption } from '@skupreme/shared/ui';

export type ExportView = 'consolidated' | 'detailed' | 'globalSummary';

export const EXPORT_VIEWS: { value: ExportView; label: string }[] = [
  { value: 'consolidated', label: 'Consolidated' },
  { value: 'detailed', label: 'Detailed' },
  { value: 'globalSummary', label: 'Global Summary' },
];

type ProviderLike = Record<string, unknown> | null | undefined;

/* The providers endpoint has answered with several shapes over time. */
function providerId(provider: ProviderLike): string {
  const id =
    provider?.id ??
    provider?._id ??
    provider?.uuid ??
    provider?.provider_id ??
    provider?.providerId;
  return id ? String(id) : '';
}

function providerName(provider: ProviderLike): string {
  const name =
    provider?.name ||
    provider?.provider_name ||
    provider?.title ||
    provider?.label ||
    provider?.display_name;
  return name ? String(name) : 'Unnamed';
}

export function toProviderOptions(providers: unknown[]): SelectOption[] {
  return providers
    .map(provider => provider as ProviderLike)
    .map(provider => ({
      value: providerId(provider),
      label: providerName(provider),
    }))
    .filter(option => option.value);
}

/** No providers picked means every provider, so the field is left out. */
export function buildExportPayload(
  view: ExportView,
  providerIds: string[],
): { view: ExportView; fulfillmentProviderIds?: string[] } {
  return providerIds.length
    ? { view, fulfillmentProviderIds: providerIds }
    : { view };
}
